import { SelectOptionType } from '@octano/global-ui';
import { useSurveyLoader } from '../../SurveyCreate/parts/SurveyCreateLoader';
import { v4 as uuidv4 } from 'uuid';
import SurveyDraftEditLoader from './SurveyDraftEditLoader';
import FormContainer from '../../SurveyCreate/parts';
import DisplayError from '../../../../../../components/info/DisplayError';
import { FormValues } from '../../SurveyCreate/parts/index';

export default function SurveyDraftEdit() {
  const { data } = useSurveyLoader();

  return (
    <SurveyDraftEditLoader>
      {({ draft }) => {
        if (!draft || !data) {
          return (
            <DisplayError
              insideCard
              textBody="No se cargaron los datos"
              retryAction={() => {}}
            />
          );
        }
        const contextOptions: SelectOptionType[] = data.surveyContexts?.map(
          (c) => ({
            label: c.name,
            value: c.id,
          }),
        );
        const periodOptions: SelectOptionType[] = data.periods?.map((p) => ({
          label: p.name,
          value: p.id,
          startDate: p.startDate,
          endDate: p.endDate,
        }));
        const scaleOptions: SelectOptionType[] = data.scales?.map((s) => ({
          label: s.title,
          value: s.id,
        }));

        const defaultValues: Partial<FormValues> = {
          id: draft.id,
          title: draft.title,
          context:
            contextOptions?.find((opt) => opt.value === draft.context) ?? null,
          period:
            periodOptions?.find(
              (opt) => opt.value === draft.content?.period?.id,
            ) ?? null,
          scale:
            scaleOptions?.find(
              (opt) =>
                opt.value ===
                draft.content?.sections?.[0]?.questions?.[0]?.scale.id,
            ) ?? null,
          startDate: draft.startDate,
          endDate: draft.endDate,
          sections: draft.content?.sections?.map((section) => ({
            id: section.id ?? uuidv4(),
            title: section.name,
            description: section.description ?? '',
            questions: section.questions.map((q) => ({
              id: q.id ?? uuidv4(),
              text: q.text,
            })),
          })),
        };

        return <FormContainer defaultValues={defaultValues} />;
      }}
    </SurveyDraftEditLoader>
  );
}
